/**
 * A Post inside the social feed
 *
 * @author Paige Ponzeka (pponzeka@yext.com)
 */
goog.provide('yext.social.post.actions');

goog.require('yext');
goog.require('yext.social.generatedcontent.routes');
goog.require('yext.socialstorm.routes');

goog.scope(function() {
  var _postactions = yext.social.post.actions;
  _postactions.iconClass = '.js-like-btn-icon';
  _postactions.textClass = '.js-like-btn-text';

  /**
   * Runs the ajax call to like a post
   * @param {!Object} data must contain partnerId, postLocId, like, onSuccess function
   */
  _postactions.likePost = function(data) {
    if (!data.partnerId || !data.postLocId || data.like == null || !data.onSuccess) {
      _postactions.onDataError(data, 'likePost: Missing Required params from object');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.likePost(
      {
        'partnerId': data.partnerId,
        'socialPostLocationId': data.postLocId,
        'like': data.like,
      },
    ), data);
  };

  /**
   * Runs ajax to 'hide' a post from the view (only works on UGC currently)
   * @param {!Object} data must contain postId onSuccess function
   */
  _postactions.hidePost = function(data) {
    if (!data.postId) {
      _postactions.onDataError(data, 'hidePost: Missing Postid');
      return;
    }

    _postactions._ajaxWrapper(yext.social.generatedcontent.routes.hidePost(
      {
        'postId': data.postId,
      },
    ), data);
  };

  /**
   * Runs ajax to delete a post
   * @param {!Object} data must contain postId onSuccess function
   */
  _postactions.deletePost = function(data) {
    if (!data.postId) {
      _postactions.onDataError(data, 'deletePost: Missing Postid');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.deletePost(
      {
        'postId': data.postId,
      },
    ), data);
  };

  /**
   * Runs ajax to retry a post failed post
   * @param {!Object} data must contain postId onSuccess function
   */
  _postactions.retryPost = function(data) {
    if (!data.postId) {
      _postactions.onDataError(data, 'retryPost: Missing Postid');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.retryPost(
      {
        'postId': data.postId,
      },
    ), data);
  };

  /**
   * Runs ajax to retry deleting a failed delete post
   * @param {!Object} data must contain postId onSuccess function
   */
  _postactions.retryDeletePost = function(data) {
    if (!data.postId) {
      _postactions.onDataError(data, 'retryDeletePost: Missing Postid');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.retryDeletePost(
      {
        'postId': data.postId,
      },
    ), data);
  };

  /**
   * Runs ajax to dismiss retry on a failed post
   * @param {!Object} data must contain postId onSuccess function
   */
  _postactions.dismissPostRetry = function(data) {
    if (!data.postId) {
      _postactions.onDataError(data, 'dismissPostRetry: Missing Postid');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.declineRetry(
      {
        'postId': data.postId,
      },
    ), data);
  };

  /**
   * Runs ajax to dismiss retry on a failed post
   * @param {!Object} data must contain postId onSuccess function
   */
  _postactions.dismissDeleteRetry = function(data) {
    if (!data.postId) {
      _postactions.onDataError(data, 'dismissDeleteRetry: Missing Postid');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.declineDeleteRetry(
      {
        'postId': data.postId,
      },
    ), data);
  };

  /**
   * Runs ajax to delete a post comment
   * @param {!Object} data must contain commentId and onSuccess function
   */
  _postactions.deleteComment = function(data) {
    if (!data.commentId) {
      _postactions.onDataError(data, 'deleteComment: Missing commentId');
      return;
    } else {
      $.ajax({
        type: 'DELETE',
        dataType: 'json',
        url: yext.socialstorm.routes.SocialPost.deleteComment(
          {
            'commentId': data.commentId,
          },
        ),
        success: data.onSuccess,
        complete: data.onAlways,
        failure: data.onFail,
      });
    }
  };

  /**
   * Runs ajax to like a post comment
   * @param {!Object} data must contain commentId, like  and onSuccess function
   */
  _postactions.likeComment = function(data) {
    if (!data.commentId || data.like == null) {
      _postactions.onDataError(data, 'likeComment: Missing required params from object');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.likeComment(
      {
        'socialCommentId': data.commentId,
        'like': data.like,
      },
    ), data);
  };

  /**
   * Runs ajax to comment on a post
   * @param {!Object} data must contain commentId, like  and onSuccess function
   */
  _postactions.submitComment = function(data) {
    if (!data.partnerId || !data.locationId || !data.postId || !data.message) {
      _postactions.onDataError(data, 'submitComment: missing required params from object');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.createComment(
      {
        'partnerId': data.partnerId,
        'postLocId': data.locationId,
        'socialPostId': data.postId,
        'message': data.message,
      }), data);
  };

  _postactions.onDataError = function(data, errorMsg) {
    if (data.onFail && yext.isFunction(data.onFail)) {
      data.onFail(data);
    }

    if (data.onAlways && yext.isFunction(data.onAlways)) {
      data.onAlways(data);
    }

    throw new Error(errorMsg);
  };

  /**
   * Private wrapper that runs ajax call with consistency
   * @param  {string} url       the url of the ajax call
   * @param {!Object} data must contain postId onSuccess function
   */
  _postactions._ajaxWrapper = function(url, data) {
    $.ajax({
      type: data.action || 'POST',
      dataType: 'json',
      url: url,
      success: data.onSuccess,
      complete: data.onAlways,
      error: data.onFail,
    });
  };

  /**
   * Updates the text on a like button
   * @param  {!jQuery}  $likeBtn the clicked like button
   * @param  {boolean} isSetLiked   true if we are setting the button to liked
   * @param  {boolean} isInprogress true if this is an inprogress button
   */
  _postactions.updateLikeText = function($likeBtn, isSetLiked, isInprogress) {
    var $likeBtnText = $likeBtn.find(_postactions.textClass);

    $likeBtn.find(_postactions.iconClass).toggleClass('active', (isSetLiked && !isInprogress));
    $likeBtn.toggleClass('isDisabled', isInprogress || false);
    if (isInprogress) {
      $likeBtnText.text(isSetLiked ? yext.msg('Like (in progress...)') : yext.msg('Unlike (in progress...)'));
    } else {
      $likeBtnText.text(isSetLiked ? yext.msg('Unlike') : yext.msg('Like'));
    }
  };

  /**
   * Runs the ajax call to update the retweet count for a post
   * @param {!Object} data must contain postLocId and delta
   */
  _postactions.retweetStatus = function(data) {
    if (!data.socialPostLocationId || data.retweet == null) {
      _postactions.onDataError(data, 'retweetStatus: Missing Required params from object');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.retweetStatus(
      {
        'socialPostLocationId': data.socialPostLocationId,
        'retweet': data.retweet,
      },
    ), data);
  };

  /**
   * Runs the ajax call to create a new post for retweets or replies
   * @param {!Object} data must contain locationId, message, and quote
   */
  _postactions.createPost = function(data) {
    // Note: data.replyPostLocId can be null
    if (!data.locationId || !data.message || data.isQuote == null || !data.targetPartners) {
      _postactions.onDataError(data, 'createPost: Missing Required params from object');
      return;
    }
    _postactions._ajaxWrapper(yext.socialstorm.routes.SocialPost.createPost(
      {
        'locationId': data.locationId,
        'message': data.message,
        'isQuote': data.isQuote,
        'replyPostLocId': data.replyPostLocId,
        'targetPartners': data.targetPartners,
        'usesSelector': true,
        'emptyForce': false,
        'emptySkip': false,
        'permissionsForce': false,
        'shareReview': false,
      },
    ), data);
  };

  _postactions.fetchLinkMetadata = function(data) {
    if (!data.url) {
      _postactions.onDataError(data, 'fetchLinkMetadata: Missing url');
    }
    _postactions._ajaxWrapper(
      yext.socialstorm.routes.Social.fetchLinkMetadata({
        'url': encodeURIComponent(data.url),
      }),
      $.extend({}, data, {
        action: 'GET',
      }));
  };
});
